type ErrorMessageViewProps = {
  title: string;
  description: string;
};

export default function ErrorMessageView({
  title = "Something went wrong",
  description = "Failed to load the content. Please try again later.",
}: ErrorMessageViewProps) {
  return (
    <div className="flex h-full min-h-96 flex-col items-center justify-center gap-2">
      <h2 className="text-3xl font-bold">{title}</h2>
      <p className="text-sm">{description}</p>
    </div>
  );
}
